import { Controller } from '@hotwired/stimulus'
import { parsePhoneNumber } from 'libphonenumber-js'

export default class extends Controller {
  static targets = ['countrySelect', 'nationalNumber', 'fullNumber', 'countryCodeDisplay']

  connect() {
    this.element.closest('form').addEventListener('submit', () => this.combineNumber())
    this.populateFromExisting()
  }

  populateFromExisting() {
    const initialNumber = this.fullNumberTarget.value
    if (initialNumber) {
      try {
        const numberWithPlus = initialNumber.startsWith('+') ? initialNumber : `+${initialNumber}`
        const phoneNumber = parsePhoneNumber(numberWithPlus)
        this.nationalNumberTarget.value = phoneNumber.nationalNumber
        this.countrySelectTarget.value = phoneNumber.country
      } catch {
        this.nationalNumberTarget.value = initialNumber
      }
    }
    this.updateDisplay()
  }

  changeCountry() {
    this.updateDisplay()
  }

  detectCountry(e) {
    try {
      const phoneNumber = parsePhoneNumber(e.target.value)
      e.target.value = phoneNumber.nationalNumber
      this.countrySelectTarget.value = phoneNumber.country
      this.updateDisplay()
    } catch {
      // noop
    }
  }

  updateDisplay() {
    const selectedOption = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]
    if (selectedOption) {
      this.countryCodeDisplayTarget.textContent = selectedOption.dataset.display || '+1'
    }
  }

  combineNumber() {
    const selectedOption = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]
    const countryCode = selectedOption.dataset.countryCode
    const nationalNumber = this.nationalNumberTarget.value.replace(/\D/g, '')
    this.fullNumberTarget.value = `+${countryCode}${nationalNumber}`
  }
}
